<template>
  <CSidebar
    aside
    :show="$store.state.asideShow"
    @update:show="(val) => $store.commit('set', ['asideShow', val])"
    colorScheme="light"
    overlaid
    size="lg"
  >
    <CSidebarClose @click.native="$store.commit('toggle', 'asideShow')" />
    <CTabs tabs class="nav-underline nav-underline-info">
      <!--   <CTab active>
        <template slot="title">
          <CIcon name="cil-list"/>
        </template>
        <CListGroup class="list-group-accent">
          <CListGroupItem 
            class="list-group-item-accent-secondary bg-light text-center 
            font-weight-bold text-muted text-uppercase small"
          >
            Today
          </CListGroupItem>
          <CListGroupItem 
            href="#" 
            class="list-group-item-accent-warning list-group-item-divider"
          >
            <div class="c-avatar float-right">
              <img 
                class="c-avatar-img" 
                src="img/avatars/7.jpg" 
                alt="admin@bootstrapmaster.com"
              >
            </div>
            <div>Meeting with
              <strong>Lucas</strong>
            </div>
            <small class="text-muted mr-3">
              <CIcon name="cil-calendar"/>&nbsp;&nbsp;1 - 3pm
            </small>
            <small class="text-muted">
              <CIcon name="cil-location-pin"/>&nbsp;&nbsp;Palo Alto, CA
            </small>
          </CListGroupItem>
          <CListGroupItem href="#" class="list-group-item-accent-info">
            <div class="c-avatar float-right">
              <img 
                class="c-avatar-img" 
                src="img/avatars/4.jpg" 
                alt="admin@bootstrapmaster.com"
              >
            </div>
            <div>Skype with <strong>Megan</strong>
            </div>
            <small class="text-muted mr-3">
              <CIcon name="cil-calendar"/>&nbsp;&nbsp;4 - 5pm
            </small>
            <small class="text-muted">
              <CIcon name="cib-skype"/>&nbsp;&nbsp;On-line
            </small>
          </CListGroupItem>
          <hr class="transparent mx-3 my-0">
          <CListGroupItem 
            class="list-group-item-accent-secondary bg-light text-center 
            font-weight-bold text-muted text-uppercase small"
          >
            Tomorrow
          </CListGroupItem>
          <CListGroupItem 
            href="#" 
            class="list-group-item-accent-danger list-group-item-divider"
          >
            <div>New UI Project - <strong>deadline</strong>
            </div>
            <small class="text-muted mr-3">
              <CIcon name="cil-calendar"/>&nbsp;&nbsp;10 - 11pm
            </small>
            <small class="text-muted">
              <CIcon name="cil-home"/>&nbsp;&nbsp;creativeLabs HQ
            </small>
            <div class="c-avatars-stack mt-2">
              <div class="c-avatar c-avatar-xs">
                <img 
                  class="c-avatar-img" 
                  src="img/avatars/2.jpg" 
                  alt="admin@bootstrapmaster.com"
                >
              </div>
              <div class="c-avatar c-avatar-xs">
                <img 
                  class="c-avatar-img" 
                  src="img/avatars/3.jpg" 
                  alt="admin@bootstrapmaster.com"
                >
              </div>
              <div class="c-avatar c-avatar-xs">
                <img 
                  class="c-avatar-img" 
                  src="img/avatars/4.jpg" 
                  alt="admin@bootstrapmaster.com"
                >
              </div>
              <div class="c-avatar c-avatar-xs">
                <img 
                  class="c-avatar-img" 
                  src="img/avatars/5.jpg" 
                  alt="admin@bootstrapmaster.com"
                >
              </div>
              <div class="c-avatar c-avatar-xs">
                <img 
                  class="c-avatar-img" 
                  src="img/avatars/6.jpg" 
                  alt="admin@bootstrapmaster.com"
                >
              </div>
            </div>
          </CListGroupItem>
          <CListGroupItem 
            href="#" 
            class="list-group-item-accent-success list-group-item-divider"
          >
            <div><strong>#10 Startups.Garden</strong> Meetup</div>
            <small class="text-muted mr-3">
              <CIcon name="cil-calendar"/>&nbsp; 1 - 3pm
            </small>
            <small class="text-muted">
              <CIcon name="cil-location-pin"/>&nbsp; Palo Alto, CA
            </small>
          </CListGroupItem>
          <CListGroupItem 
            href="#" 
            class="list-group-item-accent-primary list-group-item-divider"
          >
            <div><strong>Team meeting</strong></div>
            <small class="text-muted mr-3">
              <CIcon name="cil-calendar"/>&nbsp; 4 - 6pm
            </small>
            <small class="text-muted">
              <CIcon name="cil-home"/>&nbsp; creativeLabs HQ
            </small>
            <div class="c-avatars-stack mt-2">
              <div class="c-avatar c-avatar-xs">
                <img 
                  src="img/avatars/2.jpg" 
                  class="c-avatar-img" 
                  alt="admin@bootstrapmaster.com"
                >
              </div>
              <div class="c-avatar c-avatar-xs">
                <img 
                  src="img/avatars/3.jpg" 
                  class="c-avatar-img" 
                  alt="admin@bootstrapmaster.com"
                >
              </div>
              <div class="c-avatar c-avatar-xs">
                <img 
                  src="img/avatars/4.jpg" 
                  class="c-avatar-img" 
                  alt="admin@bootstrapmaster.com"
                >
              </div>
              <div class="c-avatar c-avatar-xs">
                <img 
                  src="img/avatars/5.jpg" 
                  class="c-avatar-img" 
                  alt="admin@bootstrapmaster.com"
                >
              </div>
              <div class="c-avatar c-avatar-xs">
                <img 
                  src="img/avatars/6.jpg" 
                  class="c-avatar-img" 
                  alt="admin@bootstrapmaster.com"
                >
              </div>
              <div class="c-avatar c-avatar-xs">
                <img 
                  src="img/avatars/7.jpg" 
                  class="c-avatar-img" 
                  alt="admin@bootstrapmaster.com"
                >
              </div>
              <div class="c-avatar c-avatar-xs">
                <img 
                  src="img/avatars/8.jpg" 
                  class="c-avatar-img" 
                  alt="admin@bootstrapmaster.com"
                >
              </div>
            </div>
          </CListGroupItem>
        </CListGroup>
      </CTab>
      <CTab>
        <template slot="title">
          <CIcon name="cil-speech"/>
        </template>
        <div class="p-3">
          <div class="message">
            <div class="py-3 pb-5 mr-3 float-left">
              <div class="c-avatar">
                <img 
                  src="img/avatars/7.jpg" 
                  class="c-avatar-img" 
                  alt="admin@bootstrapmaster.com"
                >
                <span class="bg-success c-avatar-status"></span>
              </div>
            </div>
            <div>
              <small class="text-muted">Lukasz Holeczek</small>
              <small class="text-muted float-right mt-1">1:52 PM</small>
            </div>
            <div class="text-truncate font-weight-bold">
              Lorem ipsum dolor sit amet
            </div>
            <small class="text-muted">{{lorem}}</small>
          </div>
          <hr>
          <div class="message">
            <div class="py-3 pb-5 mr-3 float-left">
              <div class="c-avatar">
                <img 
                  src="img/avatars/7.jpg" 
                  class="c-avatar-img" 
                  alt="admin@bootstrapmaster.com"
                >
                <span class="bg-success c-avatar-status"></span>
              </div>
            </div>
            <div>
              <small class="text-muted">Lukasz Holeczek</small>
              <small class="text-muted float-right mt-1">1:52 PM</small>
            </div>
            <div class="text-truncate font-weight-bold">
              Lorem ipsum dolor sit amet
            </div>
            <small class="text-muted">{{lorem}}</small>
          </div>
          <hr>
          <div class="message">
            <div class="py-3 pb-5 mr-3 float-left">
              <div class="c-avatar">
                <img 
                  src="img/avatars/7.jpg" 
                  class="c-avatar-img" 
                  alt="admin@bootstrapmaster.com"
                >
                <span class="bg-success c-avatar-status"></span>
              </div>
            </div>
            <div>
              <small class="text-muted">Lukasz Holeczek</small>
              <small class="text-muted float-right mt-1">1:52 PM</small>
            </div>
            <div class="text-truncate font-weight-bold">
              Lorem ipsum dolor sit amet
            </div>
            <small class="text-muted">{{lorem}}</small>
          </div>
          <hr>
          <div class="message">
            <div class="py-3 pb-5 mr-3 float-left">
              <div class="c-avatar">
                <img 
                  src="img/avatars/7.jpg" 
                  class="c-avatar-img" 
                  alt="admin@bootstrapmaster.com"
                >
                <span class="bg-success c-avatar-status"></span>
              </div>
            </div>
            <div>
              <small class="text-muted">Lukasz Holeczek</small>
              <small class="text-muted float-right mt-1">1:52 PM</small>
            </div>
            <div class="text-truncate font-weight-bold">
              Lorem ipsum dolor sit amet
            </div>
            <small class="text-muted">{{lorem}}</small>
          </div>
          <hr>
          <div class="message">
            <div class="py-3 pb-5 mr-3 float-left">
              <div class="c-avatar">
                <img 
                  src="img/avatars/7.jpg" 
                  class="c-avatar-img" 
                  alt="admin@bootstrapmaster.com"
                >
                <span class="bg-success c-avatar-status"></span>
              </div>
            </div>
            <div>
              <small class="text-muted">Lukasz Holeczek</small>
              <small class="text-muted float-right mt-1">1:52 PM</small>
            </div>
            <div class="text-truncate font-weight-bold">
              Lorem ipsum dolor sit amet
            </div>
            <small class="text-muted">{{lorem}}</small>
          </div>
        </div>
      </CTab> -->
      <CTab>
        <template slot="title">
          <CIcon name="cil-settings" class="text-primary" />
        </template>
        <div class="p-3">
          <h6>Preferences</h6>
          <!--  <div class="aside-options">
            <div class="clearfix mt-4">
              <small>
                <b>Date Format</b>
              </small>
              <div class="mt-2">
                <b-card no-body class="bg-dark">
                  <b-card-body class="pb-0 pt-0 pr-2">
                    <b-dropdown
                      class="float-right"
                      variant="transparent p-0"
                      right
                    >
                      <template slot="button-content">
                        <i class="icon-list"></i>
                      </template>
                      <b-dropdown-item
                        v-for="dateformat in dateformats"
                        :key="dateformat"
                        @click="handleUpdate({ dateformat })"
                        :active="userdateformat == dateformat"
                        >{{ dateformat }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <p class="mb-0">{{ userdateformat }}</p>
                  </b-card-body>
                </b-card>
              </div>
            </div>
          </div>

          <div class="aside-options">
            <div class="clearfix mt-4">
              <small>
                <b>Time Format</b>
              </small>
              <div class="mt-2">
                <b-card no-body class="bg-secondary">
                  <b-card-body class="pb-0 pt-0 pr-2">
                    <b-dropdown
                      class="float-right"
                      variant="transparent p-0"
                      right
                    >
                      <template slot="button-content">
                        <i class="icon-list"></i>
                      </template>
                      <b-dropdown-item
                        v-for="timeformat in timeformats"
                        :key="timeformat"
                        @click="handleUpdate({ timeformat })"
                        :active="usertimeformat == timeformat"
                        >{{ timeformat }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <p class="mb-0">{{ usertimeformat }}</p>
                  </b-card-body>
                </b-card>
              </div>
            </div>
          </div>

          <div class="aside-options">
            <div class="clearfix mt-4">
              <small>
                <b>Default rows per grid</b>
              </small>
              <div class="mt-2">
                <b-card no-body class="bg-info">
                  <b-card-body class="pb-0 pt-0 pr-2">
                    <b-dropdown
                      class="float-right"
                      variant="transparent p-0"
                      right
                    >
                      <template slot="button-content">
                        <i class="icon-list"></i>
                      </template>
                      <b-dropdown-item
                        v-for="(row, index) in rows"
                        :key="index"
                        @click="handleUpdate({ perpage: row })"
                        :active="user.perpage == row"
                        >{{ row }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <p class="mb-0">Rows per grid {{ user.perpage }}</p>
                  </b-card-body>
                </b-card>
              </div>
            </div>
          </div> -->
          <div class="aside-options">
            <div class="clearfix mt-4">
              <small>
                <b>Notifications Check</b>
              </small>
              <div class="mt-2">
                <b-card no-body class="bg-success">
                  <b-card-body class="pb-0 pt-0 pr-2">
                    <b-dropdown
                      class="float-right"
                      variant="transparent p-0"
                      right
                    >
                      <template slot="button-content">
                        <i class="icon-clock"></i>
                      </template>
                      <b-dropdown-item
                        v-for="beat in beats"
                        :key="beat"
                        @click="handleUpdate({ beats: beat })"
                        :active="userbeat == beat"
                        >{{ beat }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <p class="mb-0">Every {{ userbeat }}sec</p>
                  </b-card-body>
                </b-card>
              </div>
            </div>
          </div>

        </div>
      </CTab>
    </CTabs>
  </CSidebar>
</template>

<script>
import { mapGetters } from "vuex";

import { Switch as cSwitch } from "@coreui/vue";

export default {
  name: "TheAside",
  components: {
    cSwitch,
  },
  data() {
    return {
      daylight: false,
      timespan1: 0,
      timespan2: 0,
      timespan3: 0,
      timespan4: 0,
      timespans: ["24 hours", "48 hours", "7 days", "this month"],
      row1: 50,
      timeout1: "5min",
      timeouts: ["2min", "5min", "10min"],
      rows: ["5", "10", "15", "20", "50"],
      forcelogouts: ["30", "60", "90"],
      beats: ["30", "60", "90"],
      idles: ["30", "60", "90"],
      dateformats: ["dd/MM/yyyy", "MM/dd/yyyy"],
      timeformats: ["hh:mm tt", "HH:mm"],
    };
  },
  methods: {
    handleUpdate(update) {
      let item = {
        id: this.user.id,
      };
      console.log("handleUpdate", item);
      // if (update.dateformat) {
      //   item.dateformat = update.dateformat;
      // }
      // if (update.timeformat) {
      //   item.timeformat = update.timeformat;
      // }
      // if (update.perpage) {
      //   item.perpage = update.perpage * 1;
      // }
      // if (update.forcelogout) {
      //   item.forcelogout = update.forcelogout * 1000;
      // }
      // if (update.idle) {
      //   item.idle = update.idle * 1000;
      // }
      // if (update.beats) {
      //   item.beats = update.beats * 1000;
      // }
      // let payload = {
      //   endpoint: "users",
      //   action: "update",
      //   data: [item],
      // };
      // this.$store.dispatch("dataupdate", payload).then(() => {
      //   this.$store.dispatch("currentUser");
      // });
    },
  },
  computed: {
    ...mapGetters(["error", "user", "notifications", "documents"]),
    interval1() {
      return this.timespans[this.timespan1];
    },
    interval2() {
      return this.timespans[this.timespan2];
    },
    interval3() {
      return this.timespans[this.timespan3];
    },
    interval4() {
      return this.timespans[this.timespan4];
    },
    resultsFail() {
      var result = 0;
      if (this.$store.state.heartbeat.widgets) {
        const widgets = this.$store.state.heartbeat.widgets;
        if (widgets.resultsBars) {
          const dataset = widgets.resultsBars.resultsFail;
          switch (this.timespan1) {
            case 0:
              result = dataset.timespan1;
              break;
            case 1:
              result = dataset.timespan2;
              break;
            case 2:
              result = dataset.timespan3;
              break;
            case 3:
              result = dataset.timespan4;
              break;
          }
        }
      }
      return result;
    },
    resultsWarning() {
      var result = 0;
      if (this.$store.state.heartbeat.widgets) {
        const widgets = this.$store.state.heartbeat.widgets;
        if (widgets.resultsBars) {
          const dataset = widgets.resultsBars.resultsWarning;
          switch (this.timespan2) {
            case 0:
              result = dataset.timespan1;
              break;
            case 1:
              result = dataset.timespan2;
              break;
            case 2:
              result = dataset.timespan3;
              break;
            case 3:
              result = dataset.timespan4;
              break;
          }
        }
      }
      return result;
    },
    resultsScheduled() {
      var result = 0;
      if (this.$store.state.heartbeat.widgets) {
        const widgets = this.$store.state.heartbeat.widgets;
        if (widgets.resultsBars) {
          const dataset = widgets.resultsBars.resultsScheduled;
          switch (this.timespan3) {
            case 0:
              result = dataset.timespan1;
              break;
            case 1:
              result = dataset.timespan2;
              break;
            case 2:
              result = dataset.timespan3;
              break;
            case 3:
              result = dataset.timespan4;
              break;
          }
        }
      }
      return result;
    },
    resultsSuccess() {
      var result = 0;
      if (this.$store.state.heartbeat.widgets) {
        const widgets = this.$store.state.heartbeat.widgets;
        if (widgets.resultsBars) {
          const dataset = widgets.resultsBars.resultsSuccess;
          switch (this.timespan4) {
            case 0:
              result = dataset.timespan1;
              break;
            case 1:
              result = dataset.timespan2;
              break;
            case 2:
              result = dataset.timespan3;
              break;
            case 3:
              result = dataset.timespan4;
              break;
          }
        }
      }
      return result;
    },
    userforcelogout() {
      return this.user ? this.user.forcelogout * 0.001 : 0;
    },
    useridle() {
      return this.user ? this.user.idle * 0.001 : 0;
    },
    userbeat() {
      return this.user ? this.user.beats * 0.001 : 0;
    },
    userdateformat() {
      return this.user ? this.user.dateformat : 0;
    },
    usertimeformat() {
      return this.user ? this.user.timeformat : 0;
    },
  },
};
</script>
